import React from 'react';


function AdminBanner() {
    return (
        <div>
            <div className="mycontainer manage-workflow-box">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="createworkflowsection1">
                            <h4>Upload Planned Data</h4>
                            {/* <p>Lorem ipsum Lorem ipsum Lorem ipsum</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminBanner;